import { bind } from "@react-rxjs/core"
import { map, scan, switchMap } from "rxjs/operators"

import {
  ADDED_DEALER_UPDATE,
  DealerBody,
  DealerUpdate,
  REMOVED_DEALER_UPDATE,
  START_OF_STATE_OF_THE_WORLD_DEALER_UPDATE,
} from "@/generated/TradingGateway"
import { tradingGatewayServices$ } from "@/services/tradingGateway"

import { withConnection } from "../withConnection"

export const ADAPTIVE_BANK_NAME = "Adaptive Bank"

export const [useCreditDealers, creditDealers$] = bind(
  tradingGatewayServices$.pipe(
    switchMap((services) => services.dealerService.subscribe()),
    withConnection(),
    scan((acc: DealerBody[], update: DealerUpdate) => {
      switch (update.type) {
        case START_OF_STATE_OF_THE_WORLD_DEALER_UPDATE:
          return []
        case ADDED_DEALER_UPDATE:
          return [...acc, update.payload]
        case REMOVED_DEALER_UPDATE:
          return acc.filter((dealer) => dealer.id !== update.payload)
        default:
          return acc
      }
    }, []),
  ),
)

export const [useDealerNameById, _] = bind((dealerId: number | undefined) =>
  creditDealers$.pipe(
    map(
      (dealers) =>
        dealers.find((dealer) => dealer.id === dealerId)?.name ||
        "Unknown Dealer",
    ),
  ),
)

export const [useAdaptiveDealerId, adaptiveDealerId$] = bind(
  creditDealers$.pipe(
    map(
      (dealers) =>
        dealers.find((dealer) => dealer.name === ADAPTIVE_BANK_NAME)?.id,
    ),
  ),
)
